
import { request } from './axios';

function accessToken() {
  return request({
    method: "get",
    url: `/twilio/access_token`
  }, false)
}

function updateUserStatus(new_status) {
  return request({
    method: "post",
    url: `/twilio/update_user_status`,
    params: { new_status: new_status }
  }, false)
}

function fetchDialerSuggestions(lookup) {
  return request({
    method: "get",
    url: `/twilio/dialer_suggestions?lookup=${lookup}`
  }, false)
}

function fetchCallerID(id) {
  return request({
    method: "get",
    url: `/contacts/${id}/caller_id`
  }, false)
}

function fetchOnHoldCalls() {
  return request({
    method: "get",
    url: `/twilio/on_hold_calls`
  }, false)
}

function createCallRecord(params) {
  return request({
    method: "post",
    url: `/twilio/create_call_record`,
    params: params
  }, false)
}
function updateCallRecord(params) {
  return request({
    method: "patch",
    url: `/twilio/update_call_record`,
    data: params
  }, false)
}

function updateCallOutcome(params) {
  return request({
    method: "patch",
    url: `/twilio/update_outcome`,
    data: params
  }, false)
}

function pushCallToQueue(params) {
  return request({
    method: "post",
    url: `/twilio/push_call_to_queue`,
    params: params
  }, false)
}


function acceptedCall(params) {
  return request({
    method: "post",
    url: `/twilio/accepted_call`,
    params: params
  }, false)
}

const TwilioService = {
  accessToken, updateUserStatus, pushCallToQueue, fetchOnHoldCalls, createCallRecord, updateCallRecord, updateCallOutcome, acceptedCall, fetchDialerSuggestions, fetchCallerID
};

export default TwilioService;
